export default "__VITE_ASSET__aef434c5__"